import React, { useState, useEffect, useMemo, useRef } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon
} from "react-share";
import { FaInstagram } from "react-icons/fa";
import axios from "axios";
import { IoShareSocial } from "react-icons/io5";

import { toast } from 'react-toastify';
import "./ShareModal.css";
import { baseUrl } from "../../utils/api";


const ShareModal = ({
  show,
  onHide,
  shareUrl = window.location.href,
  title,
  description,
  pageId,
  hashtags = ["FundLife", "Charity", "Donation"],
}) => {
  const [shareText, setShareText] = useState("");
  // const [isGenerating, setIsGenerating] = useState(false);
  // const [, setGenerateError] = useState(null);
  // const [aiTitle, setAiTitle] = useState("");

  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [instagramImage, setInstagramImage] = useState(null);
  const [showInstagramGuide, setShowInstagramGuide] = useState(false);


  const textAreaRef = useRef(null);

  const generateAIText = async (platform) => {
    const cleanUrl = shareUrl.split("?")[0];

    setSelectedPlatform(platform);
    setIsGenerating(true);

    try {
      const { data } = await axios.post(
        `${baseUrl}/admin/socialmedia`,
        {
          url: cleanUrl,
          platform,
          campaigndescription: description
        }
      );

      if (data?.description) {
        setShareText(
          `${title}\n\n${data.description}\n\n${cleanUrl}`
        );
      } else {
        toast.error("AI did not return content");
      }
    } catch (err) {
      console.error("AI generation failed", err);
      toast.error("Failed to generate message");
    } finally {
      setIsGenerating(false);
    }
  };


  const generateInstagramImage = async () => {
  const cleanUrl = shareUrl.split("?")[0];
  setSelectedPlatform("instagram");
  setIsGenerating(true);

  try {
    // 1️⃣ Generate AI caption
    const aiRes = await axios.post(
      `${baseUrl}/admin/socialmedia`,
      {
        url: cleanUrl,
        platform: "instagram",
        campaigndescription: description
      }
    );

    const caption = aiRes.data?.description;
  const title = aiRes.data?.title;
const cta = aiRes.data?.cta;
    if (!caption) {
      toast.error("AI did not return Instagram caption");
      return;
    }

    // Show caption in textarea
    setShareText(caption);

    // 2️⃣ Generate & DOWNLOAD image (STREAM)
    const response = await axios.post(
      `${baseUrl}/admin/socialimage`,
      { caption , title,
    cta},
      { responseType: "blob" } // 🔥 IMPORTANT
    );

    // Force browser download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = "instagram-post.png";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.success("Image downloaded. Click 'Copy Text' to copy caption.");
    setShowInstagramGuide(true);

  } catch (err) {
    console.error(err);
    toast.error("Instagram image generation failed");
  } finally {
    setIsGenerating(false);
  }
};
// const generateInstagramImage = async () => {
//   const cleanUrl = shareUrl.split("?")[0];
//   setSelectedPlatform("instagram");
//   setIsGenerating(true);

//   try {
//     // 1️⃣ Generate AI caption
//     const aiRes = await axios.post(
//       `${baseUrl}/admin/socialmedia`,
//       {
//         url: cleanUrl,
//         platform: "instagram",
//         campaigndescription: description
//       }
//     );

//     const caption = aiRes.data?.description;
//     if (!caption) {
//       toast.error("AI did not return Instagram caption");
//       return;
//     }

//     // ✅ Just set text (NO clipboard here)
//     setShareText(caption);

//     // 2️⃣ Generate image
//     const imgRes = await axios.post(
//       `${baseUrl}/admin/socialimage`,
//       { caption }
//     );

//     setInstagramImage(imgRes.data.imageUrl);
//     toast.success("Image downloaded. Click 'Copy Text' to copy caption.");

//     setShowInstagramGuide(true);

//   } catch (err) {
//     console.error(err);
//     toast.error("Instagram image generation failed");
//   } finally {
//     setIsGenerating(false);
//   }
// };
  const recordShareEvent = async (platform) => {
    try {
      await axios.post(`${baseUrl}/admin/shareevent`, {
        pageId,
        shareChannel: platform,
      });
    } catch (error) {
      console.error("Failed to record share event", error);
      // ❌ Do NOT block user if API fails
    }
  };

  const handleTextChange = (e) => {
    setShareText(e.target.value);
  };

  useEffect(() => {
    if (!show) {
      setShareText("");
      setSelectedPlatform(null);
      setIsGenerating(false);
    }
  }, [show]);


  useEffect(() => {
    const el = textAreaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(Math.max(el.scrollHeight, 120), 600)}px`;
  }, [shareText, show]);


// useEffect(() => {
//   console.log("instagramimage",instagramImage)
//   if (!instagramImage) return;

//   const forceDownload = async () => {
//     try {
//       const response = await fetch(instagramImage);

//       const blob = await response.blob();

//       const blobUrl = window.URL.createObjectURL(blob);
      
//       const a = document.createElement("a");

//       a.href = blobUrl;
//       a.download = "instagram-post.png";
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);

//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Download failed", err);
//     }
//   };

//   forceDownload();
// }, [instagramImage]);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = shareText;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        alert("Text copied to clipboard!");
      } catch (err) {
        alert("Failed to copy text");
      }
      document.body.removeChild(textArea);
    }
  };
  const parsedShareContent = useMemo(() => {
    const urlPattern = /https?:\/\/[^\s]+/;
    const urlMatch = shareText.match(urlPattern);

    const parsedUrl = urlMatch ? urlMatch[0] : shareUrl;
    const cleanedText = shareText.replace(urlPattern, "").trim();

    // First line = title, rest = description
    const [firstLine, ...rest] = cleanedText.split("\n").map(l => l.trim()).filter(l => l !== "");
    return {
      parsedTitle: firstLine || title,
      parsedDescription: rest.join("\n") || description,
      parsedUrl
    };
  }, [shareText, title, description, shareUrl]);




  const shareLinks = useMemo(() => {
    const { parsedTitle, parsedDescription, parsedUrl } = parsedShareContent;
    const enc = encodeURIComponent;
    const twitterText = `${parsedTitle}\n\n${parsedDescription}`.trim();
    const whatsappText = `${parsedTitle},\n\n${parsedDescription}\n\n${parsedUrl}`.trim();
    const linkedinText = `${parsedTitle}\n\n${parsedDescription}\n\n${parsedUrl}`.trim();
    const hashtagsText = (hashtags && hashtags.length) ? `\n\n${hashtags.map(tag => `#${tag}`).join(' ')}` : '';
    const cleanDescription = parsedDescription.replace(/#\w+/g, '').trim();
    console.log('parsedfac:', {
      parsedTitle,
      parsedDescription,
      parsedUrl,
      cleanDescription
    });
    const facebookHashtagText = "#" + parsedDescription
      .replace(/[^\w\s]/g, "")  // remove punctuation
      .split(/\s+/)             // split by spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // capitalize words
      .join("");                // join 
    // const facebookHashtagText = `${parsedTitle}, ${cleanDescription}`.trim();
    console.log('texts:', {
      twitterText,
      whatsappText,
      linkedinText,
      facebookHashtagText
    });


    return {
      //    facebook: (() => {
      // Clean the random message into a valid hashtag
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(parsedUrl)}&hashtag=${enc(facebookHashtagText)}`,
      // facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(parsedUrl)}`,


      // facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(parsedUrl)}${facebookHashtagText ? `&hashtag=${getFirstNWords(facebookHashtagText, 10)}` : ''}`,
      twitter: `https://twitter.com/intent/tweet?url=${enc(parsedUrl)}&text=${enc(twitterText + " ")}${(hashtags && hashtags.length) ? `&hashtags=${enc(hashtags.join(','))}` : ''}`,
      linkedin: `https://www.linkedin.com/feed/?shareActive=true&mini=true&text=${enc(linkedinText)}`,
      whatsapp: `https://wa.me/?text=${enc(whatsappText)}`,
      gmailLink: `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(parsedTitle)}&body=${encodeURIComponent(parsedDescription + "\n\n" + parsedUrl)}`

    };
  }, [parsedShareContent, hashtags]);

  const handleNativeShare = async () => {
    const { parsedTitle, parsedDescription, parsedUrl } = parsedShareContent;

    if (navigator.share) {
      try {
        await navigator.share({
          title: parsedTitle,
          text: parsedDescription,
          url: parsedUrl,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      copyToClipboard();
    }
  };

  const SHARE_LABELS = {
    facebook: "Share on Facebook",
    twitter: "Share on Twitter",
    linkedin: "Share on LinkedIn",
    whatsapp: "Share on WhatsApp"
  };


  return (
    <>
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="share-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <h4 className="text-primary" style={{ fontWeight: 600, marginBottom: 20 }}>
            Share
          </h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4">
        {isGenerating && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255,255,255,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10
            }}
          >
            <div className="text-center">
              <div className="spinner-border text-primary" role="status" />
              <p className="mt-2">Generating message…</p>
            </div>
          </div>
        )}

        <div style={{ filter: isGenerating ? "blur(2px)" : "none" }}>

          {shareText && (
            <div className="mb-4">
              <Form.Group>
                <Form.Control
                  as="textarea"
                  ref={textAreaRef}
                  rows={6}
                  value={shareText}
                  onChange={handleTextChange}
                  className="share-preview-text"
                  placeholder="This is how your share will appear..."
                />
              </Form.Group>
            </div>
          )}

          <div className="mb-4">
            <h6 className="text-secondary mb-3">Share on Social Media</h6>
            <Row className="g-3">
              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">


                  <a
                    href={shareLinks.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="share-button"
                    aria-label="Share on Facebook"
                    onClick={(e) => {
                      e.preventDefault();              // 🔴 ALWAYS stop navigation
                      if (isGenerating) return;
                      generateAIText("facebook");

                    }}
                  >
                    <FacebookIcon size={48} round />
                  </a>
                  <small className="mt-1 text-center">Facebook</small>
                </div>
              </Col>

              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">
                  <a
                    href={shareLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="share-button"
                    aria-label="Share on X/Twitter"
                    onClick={(e) => {
                      e.preventDefault();
                      if (isGenerating) return;
                      generateAIText("twitter");


                    }}
                  >
                    <XIcon size={48} round />
                  </a>
                  <small className="mt-1 text-center">Twitter</small>
                </div>
              </Col>

              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">


                  <a
                    href={shareLinks.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="share-button"
                    aria-label="Share on LinkedIn"
                    onClick={(e) => {
                      e.preventDefault();
                      if (isGenerating) return;
                      generateAIText("linkedin");


                    }}
                  >
                    <LinkedinIcon size={48} round />
                  </a>
                  <small className="mt-1 text-center">LinkedIn</small>
                </div>
              </Col>

              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">

                  <a
                    href={shareLinks.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="share-button"
                    aria-label="Share on WhatsApp"
                    onClick={(e) => {
                      e.preventDefault();
                      if (isGenerating) return;
                      generateAIText("whatsapp");



                    }}
                  >
                    <WhatsappIcon size={48} round />
                  </a>
                  <small className="mt-1 text-center">WhatsApp</small>
                </div>
              </Col>

              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">
                  <button
                    type="button"
                    className="share-button-instagram"
                    onClick={() => {
                      if (isGenerating) return;
                      generateInstagramImage();
                    }}
                  >
                    <img
                      src="/insta.svg"
                      alt="Instagram"
                      className="instagram-logo"
                    />
                  </button>
                  <small className="mt-1 text-center">Instagram</small>
                </div>
              </Col>

              {/* <Col xs={6} md={4} lg={2}>
              <div className="d-flex flex-column align-items-center">
                <a
                  href={shareLinks.gmailLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="share-button"
                  aria-label="Share via Email"
                >
                  <EmailIcon size={48} round />
                </a>
                <small className="mt-1 text-center">Email</small>
              </div>
            </Col> */}

              <Col xs={6} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">
                  <button
                    type="button"
                    onClick={handleNativeShare}
                    className="native-share-button"
                    title="More sharing options"
                  >
                    <div className="native-share-icon">
                      <IoShareSocial size={28} className="ioshare"/>
                    </div>
                  </button>
                  <small className="mt-1 text-center">More</small>
                </div>
              </Col>
            </Row>
          </div>

          {shareText && selectedPlatform && selectedPlatform!= "instagram" && (
            <div className="text-center mb-4">
              <Button
                style={{ backgroundColor: "#235475", borderColor: "#235475" }}
                onClick={() => {
                  recordShareEvent(selectedPlatform);
                  if (selectedPlatform === "facebook") {
                    window.open(shareLinks.facebook, "_blank");
                  }
                  if (selectedPlatform === "twitter") {
                    window.open(shareLinks.twitter, "_blank");
                  }
                  if (selectedPlatform === "linkedin") {
                    window.open(shareLinks.linkedin, "_blank");
                  }
                  if (selectedPlatform === "whatsapp") {
                    window.open(shareLinks.whatsapp, "_blank");
                  }
                }}
              >
                {SHARE_LABELS[selectedPlatform]}
              </Button>
            </div>
          )}


          <div className="d-flex gap-2 justify-content-center">
            <Button
              variant="outline-primary"
              onClick={copyToClipboard}
              className="flex-fill"
            >
              <i className="fas fa-copy me-2"></i>
              Copy Text
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>

    <Modal
  show={showInstagramGuide}
  onHide={() => setShowInstagramGuide(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>How to share on Instagram</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <ol>
      <li>Image has been downloaded to your device</li>
      <li>Open the Instagram app</li>
      <li>Tap <strong>+</strong></li>
      <li>Select <strong>Post</strong> or <strong>Story</strong></li>
      <li>Choose the downloaded image</li>
      <li>Paste the caption (already copied)</li>
    </ol>
  </Modal.Body>
</Modal>
</>
  );
};

export default ShareModal;
